import React, { Component } from 'react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { intlShape, injectIntl } from 'react-intl';
import Map from '../Map/Map';
import { PropertyDetailMarkerModel } from '../Marker';
import { ControlPosition } from '../Map/Map.constants';
import Text from '../BuildingBlocks/Text';

import Address from '../Address';
import NoSSR from '../NoSSR';

import messages from './messages';
import { LocationMapContainer } from './styles';

const {
  publicRuntimeConfig: { GOOGLE_MAPS_API_KEY }
} = getConfig();

class PropertyMap extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    propertyInfo: PropTypes.shape({
      address: PropTypes.shape({
        address: PropTypes.string,
        city: PropTypes.string,
        region: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string
      }),
      name: PropTypes.string,
      slug: PropTypes.string,
      geo: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      })
    }).isRequired
  };

  /**
   * Renders the location content.
   *
   * @param {Object} property Property data object.
   * @returns {Component} A react component.
   * @memberof PropertyDetails
   */
  renderLocation(property) {
    const { intl } = this.props;

    const shouldRenderMap = property.geo && property.geo.lat && property.geo.lng;
    const shouldRenderAddress = property.address;

    return (
      <>
        {shouldRenderMap && (
          <NoSSR>
            <LocationMapContainer>
              <Map.Main
                center={[property.geo.lat, property.geo.lng]}
                disableZoomOverlay
                googleKey={GOOGLE_MAPS_API_KEY}
                markers={[
                  new PropertyDetailMarkerModel({
                    id: property.slug,
                    lat: property.geo.lat,
                    lng: property.geo.lng,
                    label: property.name
                  })
                ]}
                scrollWheelZoom={false}
                zoom={14}
                zoomControl
                zoomPosition={ControlPosition.TOP_LEFT}
                mobilePopupPaneBottom="0px"
              />
            </LocationMapContainer>
          </NoSSR>
        )}

        {/* Address */}
        {shouldRenderAddress && (
          <>
            <Text.CopyBody tagName="h3" weight="bold" noMargins>
              {intl.formatMessage(messages.address)}:
            </Text.CopyBody>
            <Text.CopyBody tagName="p" noMargins>
              <Address address={property.address} />
            </Text.CopyBody>
          </>
        )}
      </>
    );
  }

  render() {
    const { propertyInfo } = this.props;
    return <>{this.renderLocation(propertyInfo)}</>;
  }
}

export default compose(injectIntl)(PropertyMap);
